import React from "react";

import {
  Form, Radio, Select, Tooltip,
} from "antd";
import {
  getSearchableSelectProps,
  renderSelectPopupScrollbar,
  selectPopupClassNames,
} from "../../../../Common/UIComponents/SelectPopupScrollbar";

import { ReactComponent as Info } from "../../../../../assets/images/onboarding/Info.svg";
import EditableFields, { ENVIRONMENT_RESERVED_FIELD_KEYS } from "../../../../Onboarding/OnboardingForm/SubForms/FieldsForm/Components/EditableFields";
import FixedValueInput from "../../../../Onboarding/OnboardingForm/SubForms/FieldsForm/Components/FixedValueInput";

export default function OnboardingEnvironmentForm({
  layout, form, FORM_NAME, handleInitialValues, getJsonFieldName, handleEditableFields, setSubmitBtnValidation, envDropdownOptions,
}) {
  return (
    <Form
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...layout}
      form={form}
      requiredMark={false}
      name={FORM_NAME}
      validateTrigger={["onChange", "onBlur"]}
      initialValues={handleInitialValues("environment_info")}
      className="Onboarding__SampleSubmission__Form MyForm OnboardingForm"
    >
      <div className="productDetail">
        <div className="OnboardingFormTitle">Environment Details</div>
        <Form.Item>
          <div>
            <Form.Item
              name="environment_supplies_needed"
              label={<span className="MyForm__SectionLabel FieldsForm__LabelText">Do you need supplies for environment testing?</span>}
              rules={[
                {
                  required: true, message: "Please provide an answer",
                },
              ]}
            >
              <Radio.Group className="Onboarding__RadioGroup">
                <div className="Onboarding__RadioOption">
                  <Radio value="Yes">Yes</Radio>
                </div>
                <div className="Onboarding__RadioOption">
                  <Radio value="No">No</Radio>
                </div>
              </Radio.Group>
            </Form.Item>
            <div className="OnboardingContainer_Divider" />
            <Form.Item label={<span className="MyForm__SectionLabel FieldsForm__LabelText">Please enter the details you would like to include while submitting Environment samples</span>}>
              <Form.Item label={(
                <span className="MyForm__SectionLabel Onboarding__LabelText_Fields">
                  Environment Sample Submission Form Fields
                  <Tooltip title="Info to track the samples you send to the lab.">
                    <Info />
                  </Tooltip>
                </span>
            )}
              >
                <Form.Item
                  name="sample_type"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <Form.Item
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <Form.Item
                  name="physical_category"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <Form.Item
                  name="swab_number"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <Form.Item
                  name="zone"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <Form.Item
                  name="section"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <FixedValueInput />
                </Form.Item>
                <EditableFields getJsonFieldName={getJsonFieldName} onGetData={handleEditableFields} fieldLimit={2} reservedFieldKeys={ENVIRONMENT_RESERVED_FIELD_KEYS} />
                <div className="OnboardingContainer_Divider" />
                <Form.Item
                  name="environment_link"
                  label={<span className="MyForm__SectionLabel FieldsForm__LabelText">Please select the field(s) associated with the specification for your environment:</span>}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    {...getSearchableSelectProps()} // eslint-disable-line react/jsx-props-no-spreading
                    classNames={selectPopupClassNames()}
                    virtual={false}
                    listHeight={256}
                    popupRender={(menu) => renderSelectPopupScrollbar(menu, {
                      optionCount: (envDropdownOptions || []).length,
                    })}
                    options={envDropdownOptions}
                    placeholder="Select field(s)"
                    onChange={() => {
                      const fieldValue = form.getFieldValue("environment_link");
                      const editablefielsdValue = form.getFieldValue("editable_fields").filter((field) => field?.json_field === "");
                      if (fieldValue.length === 0 || editablefielsdValue.length > 0) {
                        setSubmitBtnValidation(false);
                      } else {
                        setSubmitBtnValidation(true);
                      }
                    }}
                  />
                </Form.Item>

              </Form.Item>
            </Form.Item>
          </div>
        </Form.Item>
      </div>
    </Form>
  );
}
